import { Optional, utils } from 'apprise-core/utils'
import { useMultilang } from 'apprise-frontend-core/intl/multilang'

import { CategoryReference, TagCategory, cardinalities, unknownCategory } from 'apprise-core/category'
import { useCategoryExcludes } from 'apprise-frontend-tags/category/context'
import { noModule } from 'apprise-frontend-tags/constants'




export const useCategoryModel = () => {

    const ml = useMultilang()
    const { isExcluded } = useCategoryExcludes()

    const self = {



        newCategory: (type: string = noModule.type): TagCategory => ({

            id: undefined!,
            type,
            cardinality: cardinalities.any,
            lifecycle: { state: isExcluded('active') ? 'active' : 'inactive' },
            name: {},
            description: {},
            properties: {
                field: {
                    enabled: false
                }
            }
        })

        ,

        // returns an object where none can't be found: we have no id or the id cannot be resolved.
        noCategory: (id?: Optional<CategoryReference>): TagCategory => ({

            id: id || unknownCategory,
            type: unknownCategory,
            cardinality: cardinalities.any,
            lifecycle: { state: 'active' },
            name: { en: id || undefined },
            properties: {
                field: { enabled: false }
            }
        })

        ,

        categoryComparator: (o1?: TagCategory, o2?: TagCategory) => ml.comparator(o1?.properties.field?.title ?? o1?.name, o2?.properties.field?.title ?? o2?.name)

        ,

        ordinalComparator: (o1?: TagCategory, o2?: TagCategory) => {

            const outcome = (o1?.properties.field.ordinal ?? Number.MAX_SAFE_INTEGER) - (o2?.properties.field.ordinal ?? Number.MAX_SAFE_INTEGER)

            return outcome ? outcome : self.categoryComparator(o1, o2)

        }

        ,

        clone: (category: TagCategory): TagCategory => ({ ...utils().deepclone(category), id: undefined!, guarded:false, predefined:false, lifecycle: { state: 'inactive' } })


    }


    return self
}